module.exports = __webpack_public_path__ + "static/media/NoPromo.05ba4323.svg";